import { http } from '../axios';
import { shopPrefix } from '../../config';

export async function createNewSelectionList(listName: string) {
    return await http.post<string>(`${shopPrefix}/v1/selectionlists`, { listName }).then(response => response.data);
}
